import React, { ReactElement, useEffect } from 'react';
import {
  BackButton, Breadcrumbs, getTitle, NotFoundPage, PageLoader, setTitle,
} from 'slovlex-idsk-react-components';
import { useLocation } from 'react-router';
import './navrhAktEuDetailPage.scss';
import { Heading } from 'idsk-react-components';
import GlobalErrors from '../../module/GlobalErrors';
import useNavrhAktuEuDetail from '../../module/NavrhAktuEuDetail/hooks/useNavrhAktuEuDetail';
import NavrhAktuEuDetail from '../../module/NavrhAktuEuDetail/NavrhAktuEuDetail';
import getRouteList from '../function/getRouteList';
import { Layout } from '../index';

const NavrhAktuEuDetailPage = (): ReactElement => {
  const {
    aktEuStatus,
    aktEuDetail,
  } = useNavrhAktuEuDetail();

  const currentLocation = useLocation();

  useEffect(() => {
    if (!aktEuStatus.loading) {
      setTitle(getTitle());
    }
  }, [aktEuStatus.loading]);

  if (aktEuStatus.responseCode > 399) {
    return (
      <Layout>
        <Breadcrumbs
          routeList={getRouteList(aktEuDetail, currentLocation)}
        />
        <NotFoundPage />
      </Layout>
    );
  }

  return (
    <Layout>
      <Breadcrumbs
        routeList={getRouteList(aktEuDetail, currentLocation)}
      />
      <GlobalErrors />
      <div className="akt-eu-detail-page">
        <PageLoader loading={aktEuStatus.loading}>
          <>
            {aktEuDetail && (
              <>
                <div className="back-button">
                  <BackButton buttonStyle="link" />
                </div>
                <Heading size="xl">{aktEuDetail.name}</Heading>
                <NavrhAktuEuDetail aktEu={aktEuDetail} />
              </>
            )}
          </>
        </PageLoader>
      </div>
    </Layout>
  );
};

export default NavrhAktuEuDetailPage;
